import CloseIcon from "../Images/Group 761@2x.png";
import * as Images from "../Components/Kalyanlite/assets/images";
import React, { useState } from "react";
import HoroComponent from "../Components/TrailPack/HoroComponent";
import CloseIconRed from "../Images/CloseIconRed.svg";


const AddIdProofHoroscopePopup = ({
  onClose,
  onAddIdProof,
  onAddHoroscope,
  isMuslim,
  idproofStatus,
  horoscopeStatus,
  
}) => {

  const [showHoroPopup, setShowHoroPopup] = useState(false);
  return (
    <>

     {showHoroPopup && (
       <div className="ixed inset-0 z-[999] flex items-center justify-center">
      <HoroComponent onClose={() => setShowHoroPopup(false)} />
        </div>
    )}
  <div className="fixed inset-0 z-50 bg-black bg-opacity-70 flex justify-center md:items-center items-end">
   
  <div className="relative bg-white w-full md:w-[90%] md:max-w-[520px] md:rounded-[20px] md:mb-0 rounded-t-[20px] shadow-lg p-5 flex flex-col items-center md:px-[3rem]">

     <div className="w-full md:hidden absolute top-0 left-0 text-center">
    <h2 className="text-[18px] font-bold text-[#D10A11] pt-4 pb-2">Add ID Proof & Horoscope</h2>
    <div className="border-b border-dashed border-[#D10A11] mb-3" />
  </div>
    
    {/* Close Button - mobile top left */}
    <button
      className="absolute top-[-9px] left-[-6px] hidden md:flex"
      onClick={onClose}
      aria-label="Close"
    >
      <img src={CloseIcon} alt="Close" className="w-6 h-6" />
    </button>

    <button
      className="absolute top-4 right-4  md:hidden"
      onClick={onClose}
      aria-label="Close"
    >
      <img src={CloseIconRed} alt="Close" className="w-6 h-6" />
    </button>

    {/* Icon */}
    <div className="mb-4 md:mb-0 mt-[2.5rem] md:mt-0">
      <img
        src={Images.IdProofHoroscopeIcon}
        alt="ID Proof & Horoscope"
        className="w-[9rem] h-[7rem]"
      />
    </div>

    {/* Title */}
    <h2 className="hidden md:block text-xl font-bold text-[#D10A11] text-center mb-2">
      Add ID Proof & Horoscope
    </h2>

    {/* Subtitle */}
    <p className="text-center text-[#4F4F4F] mb-6 text-sm">
      Profiles with ID Proof and Horoscope gets 10 times more responses. Click "Add" to add details.
    </p>

    {/* Add ID Proof Section */}
    <div className="flex items-center justify-between w-full mb-4">
      <span className="font-bold text-sm">Add ID Proof</span>
      {idproofStatus === "Y" ? (
        <span className="text-[#000000] flex items-center text-sm px-6">
          Done <img className="w-5 h-5 ml-2" src={Images.redtickicon} />
        </span>
      ) : (
        <button
          className={`px-10 py-1 rounded font-semibold text-sm
              bg-[#D10A11] text-white
          `}
          onClick={onAddIdProof}
        >
          Add
        </button>
      )}
    </div>

    {/* Upload/Generate Horoscope Section */}
    <div className="flex items-center justify-between w-full mb-4">
      <span className="font-bold text-sm">Upload/Generate Horoscope</span>
      {horoscopeStatus === "Y" ? (
        <span className="text-[#000000] flex items-center text-sm px-6">
          Done <img className="w-5 h-5 ml-2" src={Images.redtickicon} />
        </span>
      ) : (
        <button
          className={`px-10 py-1 rounded font-semibold text-sm ${
            isMuslim === 'Y'
              ? 'bg-gray-400 text-white cursor-not-allowed'
              : 'bg-[#D10A11] text-white'
          }`}
          disabled={isMuslim === 'Y'}
          onClick={isMuslim === 'Y' ? undefined : onAddHoroscope}
        >
          Add
        </button>
      )}
    </div>

    {/* File Types */}
    <div className="text-[13px] text-[#4F4F4F] font-semibold mb-2 text-center w-full">
      PNG, JPG, GIF, PDF (Less Than 10MB)
    </div>

    {/* Info Box */}
    <div className="bg-[#f3f3f3] rounded-[20px] flex items-center p-4 text-[#555] w-full mt-2">
      <img src={Images.WarningIcon} alt="Info" className="w-10 h-10 mr-5 ml-4" />
      <span className="text-[13px] text-[#575556]">
        The Document uploaded will reflect in your profile after verification by Kalyan Matrimony
      </span>
    </div>
  </div>
</div>


  </>
  );
};

export default AddIdProofHoroscopePopup;